import { FC, Reducer, useReducer } from 'react';

import { PropsWithOnlyChildren } from 'app/types';

import {
  GeneralContextAction,
  GeneralDispatchContext,
  GeneralState,
  GeneralStateContext,
  initialState,
} from './contexts';

const reducer: Reducer<GeneralState, GeneralContextAction> = (state, action) => {
  switch (action.type) {
    case 'setBeamerMessageCount':
      return {
        ...state,
        beamerMessageCount: action.payload.beamerMessageCount,
      };
    case 'setDevice': {
      const { currentDevice = 'desktop' } = action.payload;

      return {
        ...state,
        currentDevice,
      };
    }
    case 'setOpenFilterButton': {
      const { currentOpenFilterButton = null } = action.payload;

      return {
        ...state,
        currentOpenFilterButton,
      };
    }
    case 'reset':
      return { ...initialState };
    case 'toggleSideNav':
      return {
        ...state,
        isSideNavOpen: !state.isSideNavOpen,
      };
    case 'updateServiceWorker':
      return {
        ...state,
        isServiceWorkerUpdated: true,
      };
    case 'updateUiTheme':
      return {
        ...state,
        uiTheme: action.payload.uiTheme,
      };
    default:
      throw new Error();
  }
};

const GeneralContextProvider: FC<PropsWithOnlyChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GeneralStateContext.Provider value={state}>
      <GeneralDispatchContext.Provider value={dispatch}>
        {children}
      </GeneralDispatchContext.Provider>
    </GeneralStateContext.Provider>
  );
};

export default GeneralContextProvider;
